<template>
  <div class="card-wrapper">
    <img class="card-img" src="../../../public/custom/images/cards/card.png" alt="Card image">
    <div class="card-data-container">
      <div class="card-data-title">
        <div class="card-info">
          <div class="data-card">
            <div class="data-title">
              {{ $t('message.cardsPage.card.card') }}
            </div>
            <div class="data-desc">{{ formatPan }}</div>
          </div>
          <div class="data-card" :class="{'card-expired': false}">
            <div class="data-title">
              {{ $t('message.cardsPage.card.expiry') }}
            </div>
            <div class="data-desc">{{ formattedExpiry }}</div>
          </div>
        </div>

        <div v-if="isDefaultCard" class="default-card-bage">
            Основная карта
        </div>
      </div>
      
      <div class="actions-block">
        <div class="card-brand">
          <span v-if="isNotVerified">{{ $t('message.cardsPage.notVerified') }}</span>
        </div>
        <div class="btns-block">
          <button v-if="!isDefaultCard" @click="setDefaultCard()" class="do-main-card">Сделать основной</button>
          <div class="delete-card" @click="deleteCard()">{{ $t('message.cardsPage.card.delete') }}</div>
        </div>
      </div>
    </div>

    <div class="mobile-img-block">
      <div class="mobile-bage-block">
        <div v-if="isDefaultCard" class="default-card-bage">
          Основная карта
        </div>
      </div>
      <div class="mobile-data-block">
        <img class="mobile-card-img" src="../../../public/custom/images/cards/mobile-card.svg" alt="Card image">
        <div class="card-info mobile-card-info">
          <div class="data-card">
            <div class="data-title">
              {{ $t('message.cardsPage.card.card') }}
            </div>
            <div class="data-desc">{{ formatPan }}</div>
          </div>
          <div class="data-card" :class="{'card-expired': false}">
            <div class="data-title">
              {{ $t('message.cardsPage.card.expiry') }}
            </div>
            <div class="data-desc">{{ formattedExpiry }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-card-data-container">
      <button v-if="!isDefaultCard" @click="setDefaultCard()" class="do-main-card">Сделать основной</button>
      <div class="delete-card" @click="deleteCard()">{{ $t('message.cardsPage.card.delete') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  inject: ['$httpService'],
  props: {
    data: Object,
    defaultCardId: String
  },
  methods: {
    setDefaultCard() {
      if (!this.isDefaultCard && !this.isNotVerified) {
        this.$emit('setDefaultCard', this.data);
      }
    },
    deleteCard() {
      this.$emit('deleteCard', this.data.id);
    }
  },
  computed: {
    isDefaultCard() {
      return this.data.id === this.defaultCardId;
    },
    isNotVerified() {
      return this.data.state === 'VERIFICATION_FAILED';
    },
    formattedExpiry() {
      const month = this.data?.exp_month;
      const year = this.data?.exp_year;
      if (!month || !year) {
        return '';
      }
      return `${String(month).padStart(2, '0')}/${String(year).slice(-2)}`;
    },
    formatPan() {
      const start = String(this.data.bin).slice(0, 3);
      const middle = String(this.data.bin).slice(4, 6);

      return `${start} ${middle}** **** ${this.data.last_4}`;
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-wrapper {
    width: 100%;
    max-width: 1400px;
    padding: 36px;
    box-sizing: border-box;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    background: #F8F8F8;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 24px;
  }

  .card-wrapper:not(:last-of-type) {
    margin-bottom: 50px;
  }

  .card-img {
    object-fit: contain;
    align-self: center;
    flex-shrink: 0;
  }

  .card-data-container {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .card-data-title {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 21px;
    font-weight: 600;
    font-size: 22px;
    line-height: 130%;
    color: #333333;
    justify-content: space-between;
  }

  .card-info {
    display: flex;
    gap: 24px;
  }

  .mobile-card-info {
    width: 48%;
    flex-direction: column;

    .data-card {
      gap: 0;
    }
  }

  .card-data {
    width: 100%;
    font-weight: 600;
    font-size: 26px;
    line-height: 35px;
    color: #121212;
  }

  .data-card {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .data-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: #7a7a7a;
  }

  .data-desc {
    font-size: 18px;
    line-height: 30px;
    font-weight: 600;
  }

  .default-card-bage {
    padding: 4px 8px;
    border-radius: 6px;
    background-color: #d6f9d3;
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    color: #21a15c;
    align-self: start;
  }

  .not-checked {
    width: 38px;
    height: 38px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 50%;
  }

  .checked {
    width: 38px;
    height: 38px;
  }

  .underline,
  .mobile-underline {
    width: 100%;
    height: 2px;
    background: #ECEEF0;
    border-radius: 3px;
  }

  .actions-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    font-weight: 400;
    font-size: 22px;
    line-height: 130%;
    color: #878787;
  }

  .card-brand {
    margin-top: 15px;
    display: flex;
    color: #EB5757;
  }

  .delete-btn {
    margin-top: 6px;
    cursor: pointer;
  }

  .card-expired {
    color: #EB5757;
  }

  .btns-block {
    display: flex;
    gap: 9px;
  }

  .delete-card {
    margin-top: 24px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #878787;
    cursor: pointer;

    &:hover {
      color: black;
    }
  }

  .do-main-card {
    @include buttonWithImg;

    padding: 6px 14px;
    background-color: #fff;
    border-color: #41bf7b;
    color: #41bf7b;
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;

    &:hover {
      color: white;
      background-color: #41bf7b;
    }
  }

  .delete-card {
    @include buttonWithImg;

    padding: 6px 14px;
    background-color: #fff;
    border-color: #e1454b;
    color: #ad141a;
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;

    &:hover {
      color: white;
      background-color: #e1454b;
    }
  }

  .mobile-img-block {
    width: 100%;
    display: none;
    justify-content: space-between;
    height: auto;
    margin-bottom: 20px;

    .mobile-card-img {
      width: 48%;
    }

    .mobile-bage-block {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
    }

    .mobile-data-block {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 9px;
    }
  }

  .mobile-card-data-container {
    width: 100%;
    display: none;
    flex-direction: column;
  }

  .mobile-card-title {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    color: #333333;
  }

  .mobile-card-pan {
    margin-bottom: 15px;
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    color: #121212;
  }

  .mobile-card-expiry-title {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 18px;
    line-height: 130%;
    color: #333333;
  }

  .mobile-card-expired {
    color: #EB5757;
  }

  .mobile-card-expiry {
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    color: #121212;
  }

  .mobile-underline {
    margin-bottom: 20px;
  }

  .mobile-delete-card {
    margin-top: 0;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;

    .mobile-not-verified {
      font-size: 12px;
      color: #EB5757;
    }
  }

  @media screen and (max-width: 965px) {
    .card-wrapper:hover {
      transform: none;
    }
    .card-wrapper {
      padding: 15px;
      flex-direction: column;
    }

    .card-img {
      display: none;
    }

    .card-data-container {
      display: none;
    }

    .mobile-img-block {
      display: flex;
      flex-direction: column;
    }

    .data-check {
      width: 34px;
    }

    .not-checked,
    .checked {
      width: 34px;
      height: 34px;
    }

    .mobile-card-data-container {
      display: flex;
      gap: 9px;

      .do-main-card,
      .delete-card {
        justify-content: center;
      }
    }
  }

  @media screen and (max-width: 700px) {
    .mobile-card-info {
      gap: 0;
    }

    .data-title {
      font-size: 12px;
    }

    .data-desc {
      font-size: 13px;
      font-weight: 700;
    }
  }
</style>